import { FC } from 'react';
import { Flex, Text, useMultiStyleConfig } from '@chakra-ui/react';

import { TeamMemberTransitionDisabledReason } from '__generated__/GQL';
import SunshineIcon from 'components/_core/SunshineIcon';
import Tooltip from 'components/_core/Tooltip';

import locales from './locales';

export type MemberRoleDisabledReasonTagProps = {
  reason?: TeamMemberTransitionDisabledReason;
};

export const MemberRoleDisabledReasonTag: FC<
  MemberRoleDisabledReasonTagProps
> = ({ reason }) => {
  const styles = useMultiStyleConfig('SunshineTag', {
    colorScheme: 'gray',
    size: 'sm',
  });

  if (!reason) {
    return null;
  }

  return (
    <Flex __css={styles.container}>
      <Tooltip description={locales.short[reason]}>
        <div>
          <SunshineIcon name="information" />
        </div>
      </Tooltip>
      <Text size="sm">{locales.disabled}</Text>
    </Flex>
  );
};
